export const ONE_STOP_ROOT_PATH = '/one-stop';
export const ONE_STOP_PATH = `${ONE_STOP_ROOT_PATH}/requests`;
